import Vue from "vue";
import VueVideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";

const videojs = require("video.js");

if (typeof window !== "undefined") {
  window.videojs = videojs;
}

require("videojs-youtube");
require("videojs-contrib-hls");

if (!Vue.__graduationVideoPlayerInstalled) {
  Vue.use(VueVideoPlayer);
  Vue.__graduationVideoPlayerInstalled = true;
}
